import validate from "/var/www/formbuilder.uptodateconnect.com/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45check_45auth_45global from "/var/www/formbuilder.uptodateconnect.com/client/middleware/01.check-auth.global.js";
import api_45redirect_45global from "/var/www/formbuilder.uptodateconnect.com/client/middleware/api-redirect.global.js";
import custom_45domain_45global from "/var/www/formbuilder.uptodateconnect.com/client/middleware/custom-domain.global.js";
import manifest_45route_45rule from "/var/www/formbuilder.uptodateconnect.com/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45check_45auth_45global,
  api_45redirect_45global,
  custom_45domain_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/var/www/formbuilder.uptodateconnect.com/client/middleware/admin.js"),
  auth: () => import("/var/www/formbuilder.uptodateconnect.com/client/middleware/auth.js"),
  guest: () => import("/var/www/formbuilder.uptodateconnect.com/client/middleware/guest.js"),
  moderator: () => import("/var/www/formbuilder.uptodateconnect.com/client/middleware/moderator.js"),
  subscribed: () => import("/var/www/formbuilder.uptodateconnect.com/client/middleware/subscribed.js")
}